import React from "react";

function LogOutUser({history}) {

  // const goBack = () => {
  //   history.goBack();
  // };

  return (
    <section className="none404">
      <div className="alertWrap">
        <h2>로그아웃되었습니다.</h2>
        <p>SSO 통해서 다시 접속해주세요. </p>

        {/*<button className="btnSec mgr-8" onClick={goBack}>이전 페이지로 돌아가기</button>*/}
        {/*<button className="btnPrm">홈 바로가기</button>*/}
      </div>
    </section>
  );
}

export default LogOutUser;
